import { render, staticRenderFns } from "./detail_ownership.vue?vue&type=template&id=1f177c3e&scoped=true&"
import script from "./detail_ownership.vue?vue&type=script&lang=js&"
export * from "./detail_ownership.vue?vue&type=script&lang=js&"
import style0 from "./detail_ownership.vue?vue&type=style&index=0&id=1f177c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f177c3e",
  null
  
)

export default component.exports